import { httpRequest } from "../../http";

export class CommandDeleteKeyDate {
    async run(engagementId: number, objectiveId: number, keyDateId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/objectives/${objectiveId}/key-dates/${keyDateId}/`
        try {
            const response = await httpRequest<any>(url, { method: "DELETE" });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

